import React from 'react';
import { CheckIcon, } from '@common-fe/common-fe';
import { Option } from '@common-fe/common-fe';

import {
  DotIcon,
  DotIconWrapper,
  IconWrapper,
  Text,
  Wrapper,
} from './StepperItem.styles';

export interface StepperOption extends Option {
  active: boolean;
  focus: boolean;
  grey?: boolean;
  hidden?: boolean;
  testId?: string;
}

const SidebarItem: React.FC<StepperOption> = ({
  value,
  active,
  focus,
  testId,
  grey,
}) => (
  <Wrapper  data-testid={`sidebar_item_${testId}${active ?'_active' :''}`} active={active} focus={focus}>
    <IconWrapper>
      {active && <CheckIcon size="18px" color="iconAccent"   data-testid={`sidebar_item_${testId}_check`}/>}
      {focus && (
        <DotIconWrapper  data-testid={`sidebar_item_${testId}_focus`}>
          <DotIcon />
        </DotIconWrapper>
      )}
    </IconWrapper>
    <Text  data-testid={`sidebar_item_${testId}${active ?'_active' :''}_text`} grey={grey && !active && !focus}>{value as string}</Text>
  </Wrapper>
);
export default SidebarItem;
